// currencies are listed in order of popularity
module.exports = {
  default: "USD",
  supported: {
    USD: {
      symbol: "$",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      label: "United States Dollar"
    },
    EUR: { symbol: "€", symbol_left: 1, space: 0, cents: 1, commas: 0, label: "Euro" },
    GBP: { symbol: "£", symbol_left: 1, space: 0, cents: 1, commas: 0, label: "British Pound" },
    CAD: { symbol: "$", symbol_left: 1, space: 0, cents: 1, commas: 0, label: "Canadian Dollar" },
    AUD: { symbol: "$", symbol_left: 1, space: 0, cents: 1, commas: 0, label: "Australian Dollar" },
    BRL: { symbol: "R$", symbol_left: 1, space: 1, cents: 1, commas: 1, label: "Brazilian Real" },
    MXN: { symbol: "$", symbol_left: 1, space: 1, cents: 1, commas: 0, label: "Mexican Peso" },
    ARS: { symbol: "$", symbol_left: 1, space: 0, cents: 1, commas: 1, label: "Argentine Peso" },
    INR: { symbol: "Rs.", symbol_left: 1, space: 0, cents: 0, commas: 1, label: "Indian Rupee" }, // could be ₹ when old OS support allows it
    CNY: { symbol: "¥", symbol_left: 1, space: 0, cents: 1, commas: 0, label: "Chinese Yuan" },
    JPY: { symbol: "¥", symbol_left: 1, space: 0, cents: 0, commas: 0, label: "Japanese Yen" },
    RUB: { symbol: "р", symbol_left: 0, space: 0, cents: 1, commas: 1, label: "Russian Ruble" },
    KRW: { symbol: "₩", symbol_left: 1, space: 0, cents: 0, commas: 0, label: "South Korean Won" },
    PEN: {
      symbol: "S/.",
      symbol_left: 1,
      space: 1,
      cents: 1,
      commas: 0,
      label: "Peruvian Nuevo Sol"
    },
    PLN: { symbol: "zł", symbol_left: 0, space: 1, cents: 1, commas: 1, label: "Polish Zloty" },
    TRY: { symbol: "TL", symbol_left: 0, space: 0, cents: 1, commas: 0, label: "Turkish Lira" }, // could be ₺ when old OS support allows it
    SEK: { symbol: "kr", symbol_left: 0, space: 1, cents: 0, commas: 0, label: "Swedish Krona" },
    CZK: { symbol: "Kč", symbol_left: 0, space: 1, cents: 1, commas: 1, label: "Czech Koruna" },
    NZD: {
      symbol: "$",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      label: "New Zealand Dollar"
    },
    MAD: { symbol: "dh", symbol_left: 0, space: 1, cents: 1, commas: 0, label: "Moroccan Dirham" },
    ZAR: {
      symbol: "R",
      symbol_left: 1,
      space: 1,
      cents: 1,
      commas: 0,
      label: "South African Rand"
    },
    CLP: { symbol: "$", symbol_left: 1, space: 0, cents: 0, commas: 0, label: "Chilean Peso" },
    COP: { symbol: "$", symbol_left: 1, space: 0, cents: 0, commas: 0, label: "Colombian Peso" },
    CHF: { symbol: "CHF", symbol_left: 1, space: 0, cents: 1, commas: 0, label: "Swiss Franc" },
    DKK: { symbol: "kr", symbol_left: 1, space: 0, cents: 1, commas: 0, label: "Danish Krone" },
    ILS: {
      symbol: "₪",
      symbol_left: 1,
      space: 0,
      cents: 1,
      commas: 0,
      label: "Israeli New Shekel"
    },
    NOK: { symbol: "kr", symbol_left: 1, space: 1, cents: 1, commas: 1, label: "Norwegian Krone" },
    SGD: { symbol: "S$", symbol_left: 1, space: 0, cents: 1, commas: 0, label: "Singapore Dollar" },
    HKD: { symbol: "HK$", symbol_left: 1, space: 0, cents: 1, commas: 0, label: "Hong Kong Dollar" }
  }
};
